<template>
  <path
    d="M12 2.0202C6.49002 2.0202 2.02002 6.4902 2.02002 12.0002C2.02002 17.5102 6.49002 21.9802 12 21.9802C17.51 21.9802 21.98 17.5102 21.98 12.0002C21.98 6.4902 17.51 2.0202 12 2.0202ZM11.48 17.8802V13.7402H8.82002C8.45002 13.7402 8.20002 13.3402 8.38002 13.0102L12.06 5.8402C12.29 5.3702 13 5.5402 13 6.0702V10.2602H15.54C15.91 10.2602 16.15 10.6502 15.99 10.9802L12.43 18.1002C12.19 18.5802 11.48 18.4102 11.48 17.8802Z"
  />
</template>
